<template>
    <div class="notifications">
        <button
            class="notifications__icon"
            :class="{'notifications__icon-unread': hasUnread}"
            @click.prevent="toggleDrawer"
        >
            <i class="fas fa-bell" />
        </button>
        <div
            class="notifications__list"
            v-if="displayNotifications"
        >
            <transition-group
                name="slide"
                tag="div"
            >
                <toast
                    :notification="notification"
                    v-for="(notification) in displayNotifications"
                    :key="notification.id"
                />
            </transition-group>
        </div>
        <div
            class="notification-drawer-bg"
            @click="toggleDrawer"
            v-if="showDrawer"
        />
        <transition name="slide">
            <div
                class="notifications-drawer"
                v-if="showDrawer"
            >
                <div
                    class="notification"
                    v-for="(notification) in unreadNotifications"
                    :key="notification.id"
                >
                    <div class="notification__title">
                        {{ notification.title }}
                    </div>
                    <div
                        class="notification__body"
                        v-html="notification.body"
                    />
                    <div class="notification__time">
                        {{ notification.created_at | datetime }}
                    </div>
                    <div class="notification-toast__footer">
                        <button
                            class="btn btn-sm btn-primary"
                            v-if="notification.action_text"
                            @click="doAction(notification)"
                        >
                            {{ notification.action_text }}
                        </button>
                        <button
                            class="btn btn-sm btn-link"
                            @click="dismiss(notification)"
                        >
                            Dismiss
                        </button>
                    </div>
                </div>
                <div
                    class="notifications-drawer__empty"
                    v-if="unreadNotifications.length === 0"
                >
                    <span>No unread notifications</span>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Toast from './NotificationToastComponent';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
export default {
    components: {
        Toast,
    },

    computed: {
        ...mapGetters('notifications', [
            'unreadNotifications',
            'hasUnread',
        ]),

        ...mapState('notifications', [
            'notifications',
            'displayNotifications',
            'loading',
            'loaded',
            'showDrawer',
        ]),
    },

    mounted () {
        this.loadNotifications();
        this.requestPermission();
    },

    methods: {
        ...mapActions('notifications', [
            'loadNotifications',
            'dismiss',
            'doAction',
            'requestPermission',
        ]),

        ...mapMutations('notifications', [
            'setLoading',
            'setLoaded',
            'toggleDrawer',
        ]),
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/NotificationsOverviewComponent.vue